<script lang="ts" setup>
import type { CategoryConfig } from '~~/mocks/static/regions';

import { default as SelectedRegionsSectionCategory } from './SelectedRegionsSectionCategory.vue';

defineProps<{
	regionUrl: string;
	categories: CategoryConfig[];
	regionTitle: string;
}>();
</script>
<template>
	<div class="pointer-events-auto flex flex-wrap gap-3">
		<SelectedRegionsSectionCategory
			v-for="category in categories"
			:key="category.title"
			v-bind="category"
			:region-title="regionTitle"
		/>
		<SelectedRegionsSectionCategory
			:region-title="regionTitle"
			title="Ver bairro"
			:url="regionUrl"
		/>
	</div>
</template>
